'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@common/components';
import { cn } from '@core/utils';
import { NewBadge } from '@/app/donation/_components/NewBadge';
import { Image } from '@/components/client';
interface SpecialtiesItemProps {
  imageUrl: string;
  specialtyName: string;
  institutionName: string;
  isNew?: boolean;
  active?: boolean;
  onClick?: () => void;
}

/** 데스크톱에서 사용되는 컴포넌트 */
export const DesktopSpecialtiesItem = t0 => {
  const $ = _c(20);
  const {
    imageUrl,
    specialtyName,
    institutionName,
    isNew,
    active,
    onClick
  } = t0;
  let t1;
  if ($[0] !== active) {
    t1 = cn("relative flex size-fit flex-col items-center gap-4 border-0 p-0 pb-8", {
      "rounded-medium bg-Gray-50": active
    });
    $[0] = active;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== onClick) {
    t2 = () => onClick?.();
    $[2] = onClick;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = `${specialtyName} 이미지`;
  let t4;
  if ($[4] !== imageUrl || $[5] !== t3) {
    t4 = <Image src={imageUrl} className="m-4 size-48 object-cover" alt={t3} width={96} height={96} />;
    $[4] = imageUrl;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== active) {
    t5 = cn("font-600 text-Gray-600 typo-caption1", {
      "font-700 text-Gray-900": active
    });
    $[7] = active;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== institutionName || $[10] !== t5) {
    t6 = <p className={t5}>{institutionName}</p>;
    $[9] = institutionName;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== isNew) {
    t7 = isNew && <div className="absolute bottom-30 left-1/2 -translate-x-1/2"><NewBadge dimensions="H16" /></div>;
    $[12] = isNew;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t1 || $[15] !== t2 || $[16] !== t4 || $[17] !== t6 || $[18] !== t7) {
    t8 = <Button className={t1} theme="sub-text" onClick={t2}>{t4}{t6}{t7}</Button>;
    $[14] = t1;
    $[15] = t2;
    $[16] = t4;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  return t8;
};